import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'
import { ApiService } from '@services/api/api.service'
import { I18nRequest, I18nResponse } from '@interfaces/i-i18n'

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private url = '/rest/uimessage/translate'
  private cachedRequests: I18nResponse = {}

  constructor(private apiService: ApiService) {}

  getTranslation(data: I18nRequest[]): Observable<I18nResponse> {
    // filter out cachedRequests
    data = data.filter(
      (request: I18nRequest) =>
        !(Object.keys(this.cachedRequests).includes(request.code) || Object.keys(this.cachedRequests).includes(request?.selector)),
    )

    if (!Object.keys(data).length) return of(this.cachedRequests)

    return this.apiService
      .post(this.url, data)
      .pipe(
        map((response: any) =>
          response.data.reduce(
            (acc: I18nResponse, curr: I18nRequest) => Object.assign(acc, { [curr.selector ?? curr.code]: curr }),
            this.cachedRequests,
          ),
        ),
      )
  }
}
